// extracted by mini-css-extract-plugin
module.exports = {"Headline":"Forecast_Headline__2ZHiB","Bulletin":"Forecast_Bulletin__3qtqu","Footer":"Forecast_Footer__d5CFz"};